import { render, staticRenderFns } from "./ChangeNotify.vue?vue&type=template&id=a8bf5d4c&"
import script from "./ChangeNotify.vue?vue&type=script&lang=js&"
export * from "./ChangeNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports